import React, { FC } from 'react';

import ErrorBoundary from '@buyside/components/presentation/ErrorBoundary/errorBoundary';
import IdeaShowPage from '@buyside/components/presentation/IdeaShowPage/ideaShowPage';

const IdeaShowPageRoot: FC<{ ideaId: string }> = ({ ideaId }) => {
  if (!ideaId) return;

  return (
    <ErrorBoundary pageName="the idea">
      <IdeaShowPage ideaId={ideaId} isPublic={false} />
    </ErrorBoundary>
  );
};

export default IdeaShowPageRoot;
